<template>
  <div class="dataset-and-destination-card">
    <div class="dataset-and-destination-card__text">
      <span>Source Dataset</span>
      <div class="dataset-and-destination-card__text-value">
        <SVGIcon iconName="database" width="18px" height="18px" />
        <span>{{ sourceDataset?.name }}</span>
      </div>
    </div>
    <div v-if="sourceAnnotationSet" class="dataset-and-destination-card__text">
      <span>Edit Annotation Set</span>
      <div class="dataset-and-destination-card__text-value">
        <select
          id="edit-annotation-set-select"
          :value="annotationSetToEdit?.id"
          class="select select-sm"
          required
          @change="handleAnnotationSetToEditChanged"
        >
          <option :key="'set-null'" :value="''">Select Annotation Set To Edit</option>
          <option v-for="annotationSet in annotationSets" :key="`set-${annotationSet.id}`" :value="annotationSet.id">
            {{ annotationSet.name }}
          </option>
        </select>
      </div>
    </div>
    <!-- <div class="dataset-and-destination-card__text">
      <button
        id="stop-edit-btn"
        class="button button-secondary"
        @click="handleStopEditing"
      >
        Stop Editing
      </button>
    </div> -->
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { useStore } from 'vuex';
import SVGIcon from '@/components/SVGIcon.vue';

const props = defineProps({
  reviewSettings: {
    type: Object,
    default: null,
  },
  annotationSetToEdit: {
    type: Object,
    default: null,
  },
});

const emit = defineEmits([
  'update:annotationSetToEdit', 'stop-editing',
]);

const store = useStore();
const datasets = computed(() => store.state.datasets.datasetList);

const sourceDataset = computed(() => {
  const dataset_id = props.reviewSettings?.reviewTask?.dataset_id;
  return datasets.value.find((d) => d.id === dataset_id);
});

const annotationSets = computed(() => sourceDataset.value?.annotation_sets || []);

const sourceAnnotationSet = computed(() => {
  const source_annotation_set_id = props.reviewSettings?.reviewTask?.source_annotation_set_id;
  return annotationSets.value.find((as) => as.id === source_annotation_set_id)?.name;
});

const destinationAnnotationSet = computed(() => {
  const dest_annotation_set_id = props.reviewSettings?.reviewTask?.dest_annotation_set_id;
  return annotationSets.value.find((as) => as.id === dest_annotation_set_id)?.name;
});

function handleAnnotationSetToEditChanged(evt) {
  const selectedAnnotationSetId = parseInt(evt.target.value);
  const selectedAnnotationSet = annotationSets.value.find((set) => set.id === selectedAnnotationSetId);

  if (!selectedAnnotationSet) {
    console.warn(`Annotation set with ID ${selectedAnnotationSetId} not found.`);
    return;
  }

  emit('update:annotationSetToEdit', selectedAnnotationSet);
}

function handleStopEditing() {
  emit('stop-editing');
}
</script>

<style lang="scss" scoped>
.dataset-and-destination-card {
  display: flex;
  flex-direction: row;
  width: fit-content;
  border-radius: 8px;
  background: var(--color-primary-400);
  height: 88%;

  &__text {
    display: flex;
    flex-direction: column;
    width: 100%;
    margin: 2px 8px;
    font-size: 0.75rem;
    font-weight: 600;
    color: var(--primary-text-color-secondary);
    align-items: flex-start;
    justify-content: center;
    white-space: nowrap;
    max-width: min-content;
  }

  &__text-value {
    display: flex;
    flex-direction: row;
    font-size: 0.75rem;
    font-weight: 600;
    color: var(--primary-text-color);
    white-space: nowrap;
    gap: 4px;
    flex: 1 1 auto;
    align-items: center;
  }
}

#edit-annotation-set-select {
  height: 22px;
}

#stop-edit-btn {
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 26px;
  max-height: 26px;
  flex: 1 1 auto;
  padding: 4px 8px;
  gap: 2px;
  max-width: fit-content;
}
</style>
